import { type Method } from '../types';

export const warnIncorrectValues = (
  method: Method,
  nameVariable: string,
  allowedTypes: string[],
  constraint?: string | null
): void => {
  let text = `Invalid variables in the "${method}" method. Variable "${nameVariable}" the following types of ${allowedTypes} are available.`;

  if (constraint) {
    text += `\nWith the following constraints: ${constraint}`;
  }

  console.warn('%cPLAYDECK WARN:', 'background: red; color: white;', text);
};
